import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-tracking-number-popup',
  templateUrl: './tracking-number-popup.component.html',
  styleUrls: ['./tracking-number-popup.component.css']
})
export class TrackingNumberPopupComponent implements OnInit {
  TrackingNumber = '';
  TrackingUrl = '';
  constructor(public dialogRef: MatDialogRef<TrackingNumberPopupComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: { trackingNumber: string, TrackingUrl: string  }) {
  }

  ngOnInit() {
    this.TrackingNumber = this.data.trackingNumber;
    this.TrackingUrl = this.data.TrackingUrl;
  }

}
